<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <a
          class="btn btn-primary"
          href="#"
          data-bs-toggle="modal"
          data-bs-target="#AddMonnaieModal"
          @click="resetSelectedItem"
        >
          <i class="fa fa-plus-circle"></i>
          Ajouter une Monnaie
        </a>
      </div>
      <div class="d-flex align-items-center">
        <form class="search-bg svg-color pt-3" @submit.prevent="searchMonnaies">
          <input
            type="text"
            v-model="searchTerm"
            @keyup="searchMonnaies"
            class="form-control shadow-none text-black"
            placeholder="Rechercher une monnaie"
          />
          <button
            type="submit"
            class="bg-transparent text-primary transition p-0 border-0"
          >
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Libelle
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Valeur
              </th>
            
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
              >
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(monnaie, index) in monnaies" :key="index">
              <td class="shadow-none lh-1 fw-medium text-paragraph">
                {{ monnaie.libelle }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-paragraph">
                {{ monnaie.valeur }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary text pe-0">
                <div class="dropdown text-end">
                  <button
                    class="btn dropdown-toggle btn-primary"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Actions
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#AddMonnaieModal"
                        @click="modification(monnaie)"
                      >
                        <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                        Modifier
                      </a>
                    </li>
                    <li>
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);"
                        @click="suppression(monnaie.id, monnaies, 'monnaie', 'cette monnaie')"
                      >
                        <i class="fa fa-trash-o lh-1 me-8 position-relative top-1"></i>
                        Supprimer
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center"
      >
        <PaginationComponent
          :page="currentPage"
          :totalPages="totalPages"
          :totalElements="totalElements"
          :limit="limit"
          @paginate="handlePaginate"
        />
      </div>
    </div>
  </div>

  <AddMonnaieModal :item="selectedItem" @close="recharger" />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue';
import AddMonnaieModal from './AddMonnaieModal.vue';
import { Monnaie } from '@/models/Monnaie';
import ApiService from '@/services/ApiService';
import { error, suppression } from '@/utils/utils';
import PaginationComponent from '@/components/Utilities/Pagination.vue';

export default defineComponent({
  name: 'ListeMonnaie',
  components: {
    AddMonnaieModal,
    PaginationComponent,
  },
  setup() {
    const monnaies = ref<Array<Monnaie>>([]);
    const selectedItem = ref<number>(0);
    const searchTerm = ref<string>('');
    const currentPage = ref<number>(1);
    const totalPages = ref<number>(1);
    const totalElements = ref<number>(0);
    const limit = ref<number>(10);

    const modification = (item: Monnaie) => {
      selectedItem.value = item.id;
    };

    const resetSelectedItem = () => {
      selectedItem.value = 0;
    };

    const recharger = () => {
      getAllMonnaies(currentPage.value, limit.value, searchTerm.value);
    };

    const handlePaginate = ({ page_, limit_ }) => {
      try {
        getAllMonnaies(page_, limit_, searchTerm.value);
      } catch (err) {
        error('Erreur lors de la pagination');
      }
    };

    function getAllMonnaies(page = 1, limi = 13, searchTerm = '') {
      return ApiService.get(`/all/monnaies?page=${page}&limit=${limi}&mot=${searchTerm}&n`)
        .then(({ data }) => {
          console.log ("liste", data);
          monnaies.value = data.data.data;
          totalPages.value = data.data.totalPages || 1;
          totalElements.value = data.data.totalElements ||  monnaies.value.length;
          limit.value = data.data.limit || limi;
          currentPage.value = page;
        })
        .catch(({ response }) => {
          error(response?.data?.message || 'Erreur lors de la récupération des monnaies');
        });
    }

    const searchMonnaies = () => {
      getAllMonnaies(1, limit.value, searchTerm.value);
    };

    const changePage = (page: number) => {
      if (page >= 1 && page <= totalPages.value) {
        getAllMonnaies(page, limit.value, searchTerm.value);
      }
    };

    // const exportMotifs = () => {
    //   error('Fonctionnalité d\'exportation non implémentée');
    // };

    onMounted(() => {
      getAllMonnaies();
    });

    return {
      monnaies,
      selectedItem,
      searchTerm,
      getAllMonnaies,
      suppression,
      modification,
      recharger,
      resetSelectedItem,
      searchMonnaies,
      changePage,
      handlePaginate,
      currentPage,
      totalPages,
      totalElements,
      limit,
    };
  },
});
</script>